<h2 mat-dialog-title>{{ 'ml_151126' | translate }}</h2>
<mat-dialog-content>

</mat-dialog-content>
<mat-dialog-actions align='end'>
  
</mat-dialog-actions>